import { TelematicsContent } from '@/components/Telematics/TelematicsPageContent';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import { config } from '@/pageConfig/termsAndConditionsTelematics/us/en';
import { Box } from '@lemonade-hq/cdk';
import { DocumentTypes } from 'contentlayer/generated';
import style from 'styled-components';

const ContentWrapper = style(Box)`
  position: relative;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
`;

export default function TelematicsTermsAndConditionsPage() {
  useShowHeaderCtaOnScroll(true);

  return (
    <>
      <SEO {...config.seo} />
      <Layout pt={[40, 70]} headerActions={config.layout.headerActions}>
        <ContentWrapper px="20px" pb="40px">
          <TelematicsContent content={config.MDXContent as DocumentTypes} />
        </ContentWrapper>
      </Layout>
    </>
  );
}
